import { MenuItem, TextField } from '@material-ui/core'

import reasons, { OTHER_REASON, appDeadlineReasons, collegeOutreachReasons } from './unsubscribe-reasons'
import { UnsubscribeType } from './index'

const MAX_LENGTH = 250

type UnsubscribeReasonProps = {
  unsubscribeType: UnsubscribeType
  reason: string
  setReason: (reason: string) => void
  otherReason: string
  setOtherReason: (reason: string) => void
}

const reasonOptions: Record<UnsubscribeType, typeof reasons> = {
  default: reasons,
  appDeadline: appDeadlineReasons,
  collegeOutreach: collegeOutreachReasons,
  parentVisit: reasons,
  studentVisit: reasons,
}

const reasonLabels: Record<UnsubscribeType, string> = {
  default: `I'm unsubscribing because...`,
  appDeadline: `I don't want reminders because...`,
  collegeOutreach: `I'm unsubscribing because...`,
  parentVisit: `I'm unsubscribing because...`,
  studentVisit: `I'm unsubscribing because...`,
}

const UnsubscribeReason = ({
  unsubscribeType,
  reason,
  setReason,
  otherReason,
  setOtherReason,
}: UnsubscribeReasonProps) => {
  const charSize = otherReason.length
  const charactersRemaining = MAX_LENGTH - charSize
  return (
    <>
      <TextField
        select
        label={reasonLabels[unsubscribeType]}
        placeholder=""
        value={reason}
        onChange={(e) => {
          setReason(e.target.value)
          setOtherReason('')
        }}
        variant="outlined"
        fullWidth
        required
        margin="normal"
      >
        {reasonOptions[unsubscribeType].map(({ value, label }) => (
          <MenuItem
            key={value}
            value={value}
          >
            {label}
          </MenuItem>
        ))}
      </TextField>
      {reason === OTHER_REASON && (
        <TextField
          multiline
          label="Additional Feedback"
          value={otherReason}
          onChange={(e) => setOtherReason(e.target.value)}
          variant="outlined"
          fullWidth
          margin="normal"
          helperText={`${charactersRemaining} character${charactersRemaining === 1 ? '' : 's'} remaining`}
          inputProps={{ maxLength: MAX_LENGTH }}
        />
      )}
    </>
  )
}

export default UnsubscribeReason
